import React from 'react';
import { Skeleton } from '@mui/material';
import pagesStandardStyles from '../../../../pages/Pages.module.css';
import yardRxStyles from '../../../../pages/performance/tabs/ecommerce/yardrx/YardRx.module.css';

interface PerfYardRxSkeletonDataGridProps {
  /**
   * Whether the layout is mobile (affects first column width)
   * @default false
   */
  isMobile?: boolean;
}

/**
 * PerfYardRxSkeletonDataGrid Component - Displays loading skeleton for Yard RX DataGrid
 * Matches the exact structure of the Yard RX grid with column groups and 6 data rows
 */
const PerfYardRxSkeletonDataGrid: React.FC<PerfYardRxSkeletonDataGridProps> = ({
  isMobile = false,
}) => {
  const fixedColWidth = isMobile ? 150 : 250;

  return (
    <div
      className={`${pagesStandardStyles.dataGrid} ${yardRxStyles.yardRxGrid}`}
      style={{ width: '100%' }}>
      {/* Header skeleton - Column Groups */}
      <div style={{ display: 'flex', width: '100%', marginBottom: '1px' }}>
        <Skeleton
          variant="rectangular"
          height={52}
          sx={{
            flex: `0 0 ${fixedColWidth}px`,
            width: fixedColWidth,
            marginRight: '1px',
            backgroundColor: '#f5f5f5',
          }}
        />
        <Skeleton
          variant="rectangular"
          height={52}
          sx={{
            flex: 1,
            marginRight: '2px',
            backgroundColor: '#feeded',
            borderRight: '2px solid #757575',
          }}
        />
        <Skeleton
          variant="rectangular"
          height={52}
          sx={{
            flex: 1,
            backgroundColor: '#EDF7ED',
          }}
        />
      </div>

      {/* Row skeletons */}
      {[1, 2, 3, 4, 5, 6].map(index => (
        <div
          key={index}
          style={{ display: 'flex', width: '100%', marginBottom: '1px' }}>
          <Skeleton
            variant="rectangular"
            height={52}
            sx={{
              flex: `0 0 ${fixedColWidth}px`,
              width: fixedColWidth,
              marginRight: '1px',
              backgroundColor: index % 2 === 0 ? '#fff' : '#fafafa',
            }}
          />
          <Skeleton
            variant="rectangular"
            height={52}
            sx={{
              flex: 1,
              marginRight: '1px',
              backgroundColor: index % 2 === 0 ? '#fff' : '#fafafa',
            }}
          />
          <Skeleton
            variant="rectangular"
            height={52}
            sx={{
              flex: 1,
              backgroundColor: index % 2 === 0 ? '#fff' : '#fafafa',
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default PerfYardRxSkeletonDataGrid;
